import type { PaymentCardModel } from "@/features/paymentCards/models/PaymentCardModel";
import { useHTTP, useHTTPQuery } from "@/lib/http";

export const usePaymentCards = () => {
	const http = useHTTP("Required");

	return useHTTPQuery({
		queryKey: ["paymentCards"],
		queryFn: () => {
			return http<PaymentCardModel[]>({
				method: "GET",
				url: "/payment-card"
			});
		}
	});
};
